<template>
	<div>
		<section class="hero is-medium is-bold">
	<div class="hero-body">
		<div class="container has-text-centered">
		<div class="columns">
			<!-- <div class="column">
			</div> -->
			<div class="column is-6 is-offset-6">
			<div class="hero-text">
				<div class="hero-top-text">
				Hiring Gifted
				</div>
				<div class="hero-bottom-text">
				&nbsp;&nbsp;Psychics
				</div>
			</div>
			</div>
		</div>
		</div>
	</div>
	</section>
	<section class="section top">
	<div class="container">
		<div class="columns">
		<div class="column join">
			<h2>Join One Sun</h2>
			<h3>The Premiere Psychic Network</h3>
			<p>
			Become a psychic for one of the largest psychic networks and make
			a difference in people's lives. We are looking for candidates that
			possess psychic abilities and the ability to provide reliable,
			honest readings via phone and online chat.
			</p>
			<p>
			Work from the comfort of your home, schedule your own hours, and
			earn weekly income. We are currently seeking both English and
			Spanish-speaking psychics to fulfill our growing client base's
			needs.
			</p>
			<p>
			Your unique talents are valuable to us. If you have psychic
			abilities and the desire to share your gifts with others, fill out
			the Get Started form.
			</p>
			<hr>
			<div class="network columns is-hidden-mobile is-multiline">
			<div class="column is-12">
				<h2 class="no-h3">Our Expansive Network</h2>
				<p>
				We look to work with gifted psychics who are knowledgeable and
				experienced in the following areas:
				</p>
			</div>
			<div class="column is-6">
				<ul>
				<li><i class="fa fa-check"></i> Love &amp; Relationship</li>
				<li><i class="fa fa-check"></i> Life Questions</li>
				<li><i class="fa fa-check"></i> Tarot Readings</li>
				<li><i class="fa fa-check"></i> Astrology</li>
				<li><i class="fa fa-check"></i> Horoscopes</li>
				<li><i class="fa fa-check"></i> Future Predictions</li>
				</ul>
			</div>
			<div class="column is-6">
				<ul>
				<li><i class="fa fa-check"></i> Money &amp; Finance</li>
				<li><i class="fa fa-check"></i> Careers &amp; Goals</li>
				<li><i class="fa fa-check"></i> Spiritual Guidance</li>
				<li><i class="fa fa-check"></i> Numerology</li>
				<li><i class="fa fa-check"></i> Past Lives</li>
				<li><i class="fa fa-check"></i> Dream Analysis</li>
				</ul>
			</div>
			</div>
		</div>
		<div class="column">
			<h2>Get Started</h2>
			<h3>Become a One Sun Psychic</h3>
			<p>
			Contact us to learn more about joining One Sun as an independent
			psychic contractor. A psychic manager will get back to you within 
			48 hours. You must be 18 years or older to apply and reside in North America.
			</p>
			<ApplyForm :referral="4101026" @saved="saved" />
			<hr class="is-hidden-tablet is-hidden-desktop">
			<div class="network columns is-hidden-tablet is-hidden-desktop is-multiline">
			<div class="column is-12">
				<h2 class="no-h3">Our Expansive Network</h2>
				<p>
				We look to work with gifted psychics who are knowledgeable and
				experienced in the following areas:
				</p>
			</div>
			<div class="column is-6">
				<ul>
				<li><i class="fa fa-check"></i> Love &amp; Relationship</li>
				<li><i class="fa fa-check"></i> Life Questions</li>
				<li><i class="fa fa-check"></i> Tarot Readings</li>
				<li><i class="fa fa-check"></i> Astrology</li>
				<li><i class="fa fa-check"></i> Horoscopes</li>
				<li><i class="fa fa-check"></i> Future Predictions</li>
				</ul>
			</div>
			<div class="column is-6">
				<ul>
				<li><i class="fa fa-check"></i> Money &amp; Finance</li>
				<li><i class="fa fa-check"></i> Careers &amp; Goals</li>
				<li><i class="fa fa-check"></i> Spiritual Guidance</li>
				<li><i class="fa fa-check"></i> Numerology</li>
				<li><i class="fa fa-check"></i> Past Lives</li>
				<li><i class="fa fa-check"></i> Dream Analysis</li>
				</ul>
			</div>
			</div>
		</div>
		</div>
		<hr>
	</div>
	</section>
	<section class="section faq">
	<div class="container">
		<div class="columns">
		<div class="column">
			<h2 class="no-h3">FAQ</h2>
			<h4>How do I get started?</h4>
			<p>
			Just fill out the Get Started info and we'll call or email you
			back for an interview.
			</p>
			<h4>How do I get paid?</h4>
			<p>
			We pay weekly by direct deposit or check if you prefer.
			</p>
			<h4>How much money can I earn?</h4>
			<p>
			It's up to you. You get paid for every minute you are on the phone
			or online chat with a customer. There are bonus incentives for
			conversing with repeat customers.
			</p>
			<h4>How does the bonus work?</h4>
			<p>
			There are bonus incentives for speaking with repeat customers and
			the number of minutes you are actively working with customers in
			each pay period.
			</p>
			<h4>Is it safe to fill out your application over the internet?</h4>
			<p>
			Yes. All information is secured 24/7 by GeoTrust.
			</p>
		</div>
		</div>
		<hr>
	</div>
	</section>
	</div>
</template>

<script>
	import ApplyForm from "../shared/ApplyForm.vue"

	export default {
		components: {
			ApplyForm
		},
		methods: {
			saved() {
				this.$notify({
					group: 'global',
					type: 'success',
					title: 'Success',
					text: 'Your information has been submitted.',
				})
			}
		}
	}
</script>